<template>
  <div class="consultant consultant-xyzx">
    <div class="nav">
      <div class="navs">
        <img src="imgs/careerhome/icon_xitong.png" alt="" class="xitong">
        <span class="title" style="color:#3D90F6">
                    生涯发展管理平台
                </span>
        <div class="navRight">
          <ul class="middle">
            <li @click="$router.push('/consultant/home')">首页</li>
            <li @click="$router.push('/consultant/minestudent')">学生管理</li>
              <!-- 
              <ul class='navTab'>
                <li @click="$router.push('/consultant/minestudent')">我的学生</li>
                <li @click="$router.push('/consultant/newstudent')">新的学生</li>
              </ul> -->           
            <li @click="$router.push('/consultant/message')">消息管理</li>
          </ul>
          <img :src="person" alt="" style="width:42px">
          <span>{{uName}}</span>&nbsp; | &nbsp;
          <a @click="Jump('/login')" style="color:#3D90F6">退出</a>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "index",
  data(){
    return {
      message:['imgs/careerhome/icon_tongzhi.png','imgs/careerhome/icon_youxiaoxi.png'],
      person:'imgs/careerhome/icon_boy.png',
      uName:'',
    }
  },
  computed:{
    //用户信息
    user(){
      return this.$store.state.user
    },
    unreadNum(){
      return this.$store.state.notice.unreadNum
    }
  },
  methods:{
    //高考倒计时
    countDown(year){
      let time=new Date(year,5,7).getTime()/1000;
      let nowTime=new Date().getTime()/1000;
      this.days=Math.floor((time-nowTime)/3600/24)
      this.hours=Math.floor((time-nowTime)/3600%24)
      this.minutes=Math.floor((time-nowTime)/60%60)
      this.seconds=Math.floor((time-nowTime)%60)
      this.hours=this.hours<10?"0"+this.hours:this.hours
      this.minutes=this.minutes<10?"0"+this.minutes:this.minutes
      this.seconds=this.seconds<10?"0"+this.seconds:this.seconds
    },
    Jump(path){
      window.sessionStorage.clear();
      this.$router.push(path);
    },
    tiaozhuan(){
      if(this.$route.path=='/careerArchives'){
        this.$router.push('/refresh')
      }else {
        this.$router.push('/careerArchives');
      }
    }
  },
  watch: {
    user(val){
      this.uName=val.name;
      this.teacherId=val.teacher_id;
      if(val.sex==1){
        this.person='imgs/careerhome/icon_boy.png'
      }else{
        this.person='imgs/careerhome/icon_girl.png'
      }
      this.countDown(val.baccll_year)
      setInterval(()=>{
        this.countDown(val.baccll_year)
      },1000)
    },
  },
  created() {
    let token= window.sessionStorage.getItem('ymtxToken');
    window.sessionStorage.setItem('token', token);
    window.sessionStorage.getItem('ymtxToken');
    ///获取个人信息
    this.$store.dispatch({
      type:'getUserInfo',
      token:token,
      vue:this
    });
    this.uName=this.user.name;
    this.teacherId=this.user.teacher_id;
    this.countDown(this.user.baccll_year)
    //获取未读通知
    this.$store.dispatch('getUnreadNum',token);
    //获取省市区
    this.$store.dispatch('getCitys');
  },
  mounted() {
    let url=window.location.hash,
        navs=$(".middle>li")
        navs.removeClass('navActive')
        if(url.indexOf('home')>=0){
          navs.eq(0).addClass('navActive')
          return;
        }
        if(url.indexOf('mineStudent')>=0||url.indexOf('newStudent')>=0){
          navs.eq(1).addClass('navActive')
          return;
        }
        if(url.indexOf('message')>=0){
          navs.eq(2).addClass('navActive')
          return;
        }
  },
  updated(){
    let url=window.location.hash,
        navs=$(".middle>li")
        navs.removeClass('navActive')
        if(url.indexOf('home')>=0){
          navs.eq(0).addClass('navActive')
          return;
        }
        if(url.indexOf('minestudent')>=0||url.indexOf('newstudent')>=0){
          navs.eq(1).addClass('navActive')
          return;
        }

        if(url.indexOf('message')>=0){
          navs.eq(2).addClass('navActive')
          return;
        }
  }
}
</script>
<style  lang="less" scoped>
  .consultant{
  padding-bottom: 20px;
  height: 100%;
  .nav{
    width: 100%;
    height: 66px;
    background: #fff;
    //overflow: hidden;
    .navs{
      width: 1200px;
      height: 100%;
      position: relative;
      margin:0 auto;
      line-height:66px;
      font-size:13px;
      color:#333;
      .navRight{
        position: absolute;
        right: 0;
        top: 0;
        width: auto;
        height: 100%;
        span{
          letter-spacing: 2px;
        }
        img{
          margin-right: 10px;
        }
        .tongzhi{
          margin-right:40px;
        }
        .tongzhiImg{
          cursor: pointer;
        }
        a{
          color:#333;
          letter-spacing: 1.5px;
        }
      }
      .xitong{
        width: 36px;
        height: auto;
        margin-right:5px;
        position: relative;
        top:-1px;
      }
      .rili{
        margin-right: 5px;
      }
      .title{
        font-size: 17px;
        color:#333333;
        letter-spacing: 2px;
        text-align: center;
        font-weight: bolder;
        margin-right: 38px;
      }
      .number{
        color:red;
        margin-right: 3px;
        font-weight: bolder;
      }
    }
  }
  .careerBox{
    width: 1200px;
    margin: 20px auto;
    overflow: hidden;
    .left{
      width: 160px;
      height: 480px;
      margin-top: 1px;
      float: left;
      background: #fff;
      border-radius: 3px;
      box-shadow: 0 0 3px #dedede;
      position: relative;
      z-index: 3;
      .routers{
        li{
          height: 44px;
          width: 100%;
          line-height: 44px;
          font-size: 14px;
          text-indent:22px;
          color:#666;
          /*font-weight: bolder;*/
          letter-spacing: 2px;
          cursor: pointer;
          transition: 0.2s;
          &:nth-child(1){
            line-height: 66px;
            height: 66px;
            font-size: 16px;
            border-bottom: 1px solid #F7F6FB;
            color:#333333;
            font-weight: normal;
          }
          img{
            margin-right: 15px;
            position: relative;
            top:-2px;
          }
          .active {
            display: none;
          }
          .unactive {
            display: inline-block;
          }
        }
        .router-link-active {
          font-weight:bolder;
          color:#3C8CEB;
        }
        .home {
          background: none;
          .active {
            display: none;
          }
          .unactive {
            display: inline-block;
          }
        }
      }
    }
    .right{
      width: 1024px;
      float: left;
      .rightTop{
        width: 100%;
        height: 65px;
        background: #fff;
        border-radius: 3px;
        box-shadow: 0 0 3px #dedede;
      }
    }
  }
  .middle{
    font-size: 14px;
    font-weight: 400;
    color: #5C5C5C;
    display: flex;
    justify-content: space-between;
    width: 260px;
    float: left;
    margin-right: 50px;
    &>li{
      position: relative;
      cursor: pointer;
      height: 66px;
      border-bottom: 2px solid transparent;
      &:hover .navTab{
        display: block;
      }
      .navTab{
        position: absolute;
        left: -26px;
        top:66px;
        z-index: 3;
        box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
        display: none;
        li{
          width: 108px;
          height: 40px;
          line-height: 40px;
          background: #f4f4f4;
          font-size: 14px;
          color: #5C5C5C;
          text-align: center;
          &:hover{
            background: #fff;
            color: #3d90f6;
          }
        }
      }
    }
  }
  .navActive{
    color: #3d90f6;
    border-bottom: 2px solid #3d90f6 !important;
  }
}
</style>
<style lang="less">
  body{
    background: none;
  }
  html{
    // background: url(/imgs/xueyezixun/consultant/student/bg.png) center center !important;
    background: #ffff;
  }
  .common-search{
    width: 64px;
    height: 32px;
    background: linear-gradient(270deg, #2AB1FE 0%, #05A0FF 100%, rgba(1, 136, 235, 0.72) 100%);
    border-radius: 3px;
    cursor: pointer;
    float: right;
    position: relative;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 32px;
  &:hover{
     opacity: .9;
   }
  img{
    width: 24px;
    position: relative;
  }
}
  .consultant-xyzx{
    *{
      box-sizing: border-box;
    }
  }
</style>